import React from "react";
import { Link } from "react-router-dom";
import EmployeeCard from "../../components/EmployeeCard";
import "./style.scss";
import useFetch from "../../hooks/useFetch";

function Contact({content}) {
  const [contentArray] = useFetch("/employees?acf_format=standard", []);
  return (
    <div className="Contact">
      <div className="Contact__companies">
        {content.companies?.map((company, index) => (
          <ContactCompany key={index} company={company} />
        ))}
      </div>
      <div className="Contact__employees">
        {content.employees?.map((employee, index, array) => {
          const found = contentArray.find((item) => item.id === employee.ID);
          if (!found) return null;
          return (
            <EmployeeCard
              className={array.length % 2 !== 0 && index === array.length - 1 ? "Contact__employee" : ""}
              key={index}
              data={found}
            />
          )
        })}
      </div>
    </div>
  );
}

function ContactCompany({company}) {
  return (
    <Link to={company.link.url} target={company.link.target} className="ContactCompany">
      <img className="ContactCompany__logo" src={company.logo.sizes.thumbnail} alt={company.logo.alt} />
      <span className="ContactCompany__text">{company.link.title}</span>
    </Link>
  );
}

export default Contact;
